/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export { default as showsAndMoviesReducer } from "./showsAndMoviesSlice";
export {
  // Focus setters
  focusShowsAndMoviesFilter,
  focusShowsAndMoviesGenre,
  focusShowsAndMoviesTile,
  // D-pad commit actions
  applyShowsAndMoviesFilter,
  applyShowsAndMoviesGenre,
  // View → state sync
  setShowsAndMoviesCarouselItemCounts,
  // D-pad navigation
  navigateShowsAndMoviesLeft,
  navigateShowsAndMoviesRight,
  navigateShowsAndMoviesUp,
  navigateShowsAndMoviesDown,
  // Fetching
  loadShowsAndMoviesScreenNavigation,
  fetchShowsAndMoviesCarousels,
  refreshShowsAndMoviesCarousels,
  loadMoreShowsAndMoviesCarousels,
  loadMoreShowsAndMoviesCarouselItems,
  // Selectors
  selectShowsAndMoviesSelectedFilter,
  selectShowsAndMoviesSelectedGenres,
  selectShowsAndMoviesSelectedApiGenres,
  selectShowsAndMoviesScreenTemplateType,
  selectShowsAndMoviesFilterOptions,
  selectShowsAndMoviesGenreOptions,
  selectShowsAndMoviesCarousels,
  selectIsLoadingShowsAndMoviesCarousels,
  selectShowsAndMoviesLoadingCarouselIds,
  selectShowsAndMoviesHasMoreCarousels,
  selectShowsAndMoviesCarouselsError,
  selectShowsAndMoviesNavigationError,
  selectShowsAndMoviesFocusRegion,
  selectShowsAndMoviesFocusedFilterIndex,
  selectShowsAndMoviesFocusedGenreIndex,
  selectShowsAndMoviesFocusedCarouselIndex,
  selectShowsAndMoviesFocusedItemIndex,
  selectShowsAndMoviesCarouselScrollPositions
} from "./showsAndMoviesSlice";
export { hasGenreSubFilters } from "./showsAndMoviesFilters";
export {
  SHOWS_AND_MOVIES_API_ENDPOINT,
  SHOWS_AND_MOVIES_CONTENT_HIGHLIGHT_DWELL_MS,
  SHOWS_AND_MOVIES_SCREEN_ID,
  SHOWS_AND_MOVIES_SCREEN_NAME
} from "./showsAndMoviesConstants";
export {
  ShowsAndMoviesFilterId,
  ShowsAndMoviesGenreId,
  ShowsAndMoviesFocusRegion
} from "./showsAndMovies.types";
export type {
  ShowsAndMoviesState,
  TShowsAndMoviesFilterMeta,
  TShowsAndMoviesGenreMeta,
  TShowsAndMoviesScreenTemplateType,
  TShowsAndMoviesCarouselData,
  TShowsAndMoviesCarouselState
} from "./showsAndMovies.types";
